import { render, staticRenderFns } from "./ReplacePlayer.vue?vue&type=template&id=b398bf4c&scoped=true"
import script from "./ReplacePlayer.vue?vue&type=script&lang=js"
export * from "./ReplacePlayer.vue?vue&type=script&lang=js"
import style0 from "./ReplacePlayer.vue?vue&type=style&index=0&id=b398bf4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b398bf4c",
  null
  
)

export default component.exports